import type { StudentTag } from './types/student-tag'

/** Display as "Last, First" per user story (preserves original casing). */
export function formatStudentTagLabel(tag: StudentTag): string {
  return `${tag.lastName}, ${tag.firstName}`
}

/** Case-insensitive sort by last name, then first name. */
export function sortStudentTags<T extends StudentTag>(tags: T[]): T[] {
  return [...tags].sort((a, b) => {
    const byLast = a.lastName.localeCompare(b.lastName, undefined, { sensitivity: 'base' })

    if (byLast !== 0) return byLast
    return a.firstName.localeCompare(b.firstName, undefined, { sensitivity: 'base' })
  })
}
